/* unplugin-vue-components disabled */import script from "./tip-header.vue?vue&type=script&setup=true&lang=js"
export * from "./tip-header.vue?vue&type=script&setup=true&lang=js"

import "./tip-header.vue?vue&type=style&index=0&id=0ef4284e&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ef4284e"]])

export default __exports__